"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paintStyleDefault = void 0;
exports.paintStyleDefault = {
    faceColorSLA: [80, 50, 0.5],
    faceColorHighlightedSLA: [80, 50, 0.7],
    borderRadiusPercent: 5,
    borderColorSLA: {
        notSelected: [80, 50, 1],
        selected: [100, 80, 1]
    }
};
